<template>
  <v-container class="container--max ch-section" tag="section" v-if="featuredPost">
    <v-row>
      <v-col cols="12">
        <div class="ch-section__titleX accent--text">
          <v-btn text color="accent" href="/local-government">Local Government <v-icon small right>mdi-chevron-right</v-icon></v-btn>
          <v-btn text color="accent" href="/parliament">Parliament <v-icon small right>mdi-chevron-right</v-icon></v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="ch-post ch-post--featured" :href="featuredPost.link" flat>
          <v-img :src="featuredPost.image ? featuredPost.image : featuredPost.author_image" :aspect-ratio="16/9" cover class="grey lighten-4"></v-img>
          <v-card-title v-html="featuredPost.title" class="ch-post__title font-weight-bold text--caslon"></v-card-title>
          <v-card-subtitle class="primary--text py-1" v-html="featuredPost.category.name"></v-card-subtitle>
          <v-card-text v-html="featuredPost.excerpt"></v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="mt-n4">
        <v-card class="mb-2 ch-post ch-post--secondary" v-for="(item, i) in otherItems" :key="i" :href="item.link" flat>
          <v-card-title v-html="item.title" class="ch-post__title ch-post__subtitle text--caslon"></v-card-title>
          <v-card-subtitle class="primary--text py-2" v-html="item.category.name"></v-card-subtitle>
          <!-- <v-card-text v-html="item.excerpt"></v-card-text> -->
        </v-card>
      </v-col>
    </v-row>
    <!-- <v-divider></v-divider> -->
  </v-container>
</template>

<script>
  export default {
    name: 'HomeGovernment',

    mixins: [
      require('./section.js').default
    ],

    methods: {
      getGovernmentPosts() {
        this.$axios.get('/wp-json/wp/v2/posts?exclude=' + this.excludedIds
          + '&categories=' + this.categories
          + '&filter[orderby]=date&order=desc&per_page=5')
        .then(response => {
          this.items = response.data
        })
      }
    },

    mounted() {
      this.getGovernmentPosts()
    }
  }
</script>